 <div *ngIf="(listPosts != null)">
  <app-banners secaoUrl="blog"></app-banners>

   <div class="blog-content">
     <div class="row">
       <div class="col-9">
         <p class="title-form-pages p-5 pb-4">BLOG</p>
         <div class="container">
           <div class="grid-posts">
             <div class="post-block" *ngFor="let post of listPosts let i = index" style="cursor: pointer;">
               <div (click)="openPost(post)">
                 <img class="img-fluid" [src]="apiService.getCover(post)" alt="">
                 <p class="data">{{ post.date | date: 'dd/MM/yyyy'}}
                   <span class="descricao-categoria limitar-linhas"
                     *ngIf="post.categorias && post.categorias.length > index">
                     | {{ post.categorias[index].name }}
                   </span>
                 </p>
                 <p class="titulo" [innerHtml]="post.title.rendered"></p>
                 <p class="descricao" [innerHtml]="post.excerpt.rendered"></p>
               </div>
             </div>
           </div>
         </div>
         <div class="text-center" *ngIf="listPosts.length < allPosts.length">
           <button (click)="loadMorePosts(6)" class="btn-ver-mais w-50">CARREGAR MAIS</button>
         </div>

         <div class="return-to-search-btn wrap-max-width">
           <button class="btn btn-light" (click)="scrollToTop()">
             <i class="bi bi-arrow-up"></i>
           </button>
         </div>

       </div>

       <div class="col-3 blog">

         <a href="/blog">
           <p class="titulo-categoria pt-4 pb-3"> Categorias</p>
         </a>
         <div class="lista-categorias mt-3">

           <div class="desc-categoria p-2" *ngFor="let categoria of categorias">

                 <p (click)="openCategoriaId(categoria)" *ngIf="categoria">
                  {{ categoria.name.charAt(0).toUpperCase() + categoria.name.slice(1).toLowerCase() }} ({{ categoria.count }})
                </p>
          </div>
              <p class="desc-categoria p-2" (click)="openCategoriaId()" *ngIf="quantityPostWithOutCategory > 0"> Sem Categoria ({{quantityPostWithOutCategory}})</p>

         </div>

         <p class="titulo-categoria pt-4 pb-3" > TAGS</p>
          <button *ngFor="let tag of tags" class="tags mt-3" (click)="openTag(tag)">{{ tag.name.charAt(0).toUpperCase() + tag.name.slice(1).toLowerCase() }}</button>
          </div>
     </div>
   </div>
 </div>

